
import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { ErrorBoundary } from "./providers/ErrorBoundary";
import { QueryProvider } from "./providers/QueryProvider";
import { ToastProvider } from "./providers/ToastProvider";
import ConfirmDialogProvider from "./components/common/ConfirmDialog";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <ToastProvider>
          <ConfirmDialogProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ConfirmDialogProvider>
        </ToastProvider>
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>
);
